import type { PaginationElement } from '@/utils/pagination';
import { PaginationButton } from './PaginationButton';

interface PaginationElementComponentProps {
  element: PaginationElement;
  currentPage: number;
  handlePageChange: (page: number) => void;
}

export const PaginationElementComponent = ({
  element,
  currentPage,
  handlePageChange,
}: PaginationElementComponentProps) => {
  switch (element.type) {
    case 'number':
      return (
        <PaginationButton
          isActive={currentPage === element.value}
          onClick={() => handlePageChange(element.value)}
        >
          {element.value}
        </PaginationButton>
      );
    case 'ellipsis':
      return (
        <span className="relative z-10 inline-flex items-center px-4 py-2 text-gray text-sm">
          ...
        </span>
      );
    default:
      element satisfies never;
      throw new Error(`Unknown pagination element type: ${element}`);
  }
};
